import React, { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { FormikObj, typeOptions } from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import TextArea from "../../common/textfield/TextArea";
import { Tooltip } from "@mui/material";
import { ArrowBack, DeleteOutline } from "@mui/icons-material";
import Select from 'react-select';
import { createGroup } from "../../api/Group";
import { getPractitionerList } from "../../api/Individual";
import moment from "moment";
import PatientSelectModal from "../../common/components/PatientSelectModal.js";
function AddGroup() {
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false)
    const [organizations, setOrganizations] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [showPatientSelectionModal, setShowPatientSelectionModal] = useState(false);
    const [patientSelectionIndex, setPatientSelectionIndex] = useState(null);

    const formik = useFormik({
        ...FormikObj,
        onSubmit: (values) => { 
            values.name = values.name.trim();
            values.description = values.description.trim();
            setBtnLoading(true) 
            createGroup({
                ...values,
                member: values?.member.map(item => ({
                    entity: {
                        display: item?.name,
                        reference: `${item?.type}/${item?.id}`,
                        type: item?.type
                    },
                    period: {
                        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                        end: null
                    },
                    inactive: false
                })),
                quantity: values?.member.length,
            }).then((res) => {
                navigate("/app/manage-groups");
                success(res.message);
            }).catch(res => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
                .finally(() => setBtnLoading(false));
        },
    });

    
    const handleOrganizationSelect = (selected) => {
        const orgId = selected?.value || "";
        formik.setFieldValue("orgId", orgId);
        formik.setFieldValue("type", "");
        formik.setFieldValue("member", []);
        setUsersList([]);
        
    };
    const handleTypeSelect = async (event) => {
        const type = event?.target?.value;
        formik.setFieldValue("type", type);
        formik.setFieldValue("member", []);
    
        const orgId = formik.values.orgId;
        if (!orgId) return console.warn("Organization ID not selected.");
    
        try {
            let res;

            if (type === "Practitioner") {
                res = await getPractitionerList(orgId);
            } else if (type === "Patient") {
                // For patients we use PatientSelectModal instead of dropdown,
                // so we don't need to populate usersList.
                setUsersList([]);
                return;
            }
            const capitalizeFirstLetter = (str) => {
                return str
                    ?.split(' ')  
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
                    .join(' '); 
            }; 
            const userlist = res?.result?.map((user) => ({
                name: capitalizeFirstLetter(user?.name?.[0]?.text),
                value: user?.id,
                type: user?.resourceType,
                label: capitalizeFirstLetter(user?.name?.[0]?.text) || "Unnamed",
                id: user?.id,
            })) || [];
    
            setUsersList(userlist);
        } catch (err) {
            console.error("Error fetching list:", err);
        }
    };
    

    const onSuccessOrg = (data) => {
        setOrganizations(data?.map((org) => org = { ...org, "value": org.id }))
    };

    const handleOpenPatientModalForIndex = (index) => {
        setPatientSelectionIndex(index);
        setShowPatientSelectionModal(true);
    };

    const handlePatientSelected = (patient) => {
        if (!patient) {
            setShowPatientSelectionModal(false);
            setPatientSelectionIndex(null);
            return;
        }

        const displayName = patient?.name?.[0]?.text
            ?.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ') || "(Unnamed)";

        const newMemberEntry = {
            name: displayName,
            value: patient?.id,
            type: "Patient",
            label: displayName,
            id: patient?.id,
        };

        const currentMembers = formik.values.member || [];
        let updatedMembers = [];

        if (
            patientSelectionIndex !== null &&
            patientSelectionIndex >= 0 &&
            patientSelectionIndex < currentMembers.length
        ) {
            updatedMembers = [...currentMembers];
            updatedMembers[patientSelectionIndex] = newMemberEntry;
        } else {
            updatedMembers = [...currentMembers, newMemberEntry];
        }

        formik.setFieldValue("member", updatedMembers);
        setShowPatientSelectionModal(false);
        setPatientSelectionIndex(null);
    };

    const handleRemovePatientAtIndex = (index) => {
        const currentMembers = formik.values.member || [];
        const updatedMembers = currentMembers.filter((_, i) => i !== index);
        formik.setFieldValue("member", updatedMembers);
    };

    useOrgQuery({ onSuccess: onSuccessOrg });

    const orgSelectOptions = organizations?.map((o) => ({ label: o?.name, value: o?.value })) || [];

    return (
        <section className="common-listing">
            <div className="heading-wrap mb-3">
                <Tooltip title="Go back">
                    <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </div>
                </Tooltip>
            </div>
            <div className="custom-card p-4">
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col>
                            <TextInput keyField={"name"} label={"Name"} formik={formik} placeholder={"Name"} />
                        </Col>
                        <Col>
                            <SearchSelect
                                keyField={"orgId"}
                                label={"Select Organization"}
                                formik={formik}
                                options={orgSelectOptions}
                                onChange={handleOrganizationSelect}
                                value={orgSelectOptions?.find((o) => o?.value === formik.values.orgId) || null}
                                placeholder={"Select Organization"}
                            />
                        </Col>
                        <Col>
                            <SelectFiled
                                keyField={"type"}
                                label={"Select Type"}
                                formik={formik}
                                options={ typeOptions } 
                                onChange={handleTypeSelect}
                            />
                        </Col>
                    </Row> 
                    <Row>
                        
                        <Col>
                            {formik.values.type === "Patient" ? (
                                <div className="field-wrap">
                                    <label>Select Members</label>
                                    {Array.isArray(formik.values.member) &&
                                    formik.values.member.length > 0 ? (
                                        <>
                                            {formik.values.member.map((member, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        marginBottom: "8px",
                                                    }}
                                                >
                                                    <Button
                                                        type="button"
                                                        variant="secondary"
                                                        onClick={() =>
                                                            handleOpenPatientModalForIndex(index)
                                                        }
                                                    >
                                                        {member?.name || "Select Patient"}
                                                    </Button>
                                                    <Tooltip title="Delete">
                                                        <span
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                handleRemovePatientAtIndex(index)
                                                            }
                                                        >
                                                            <DeleteOutline
                                                                style={{
                                                                    fontSize: 20,
                                                                    color: "#dc3545",
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                            ))}
                                            <Button
                                                type="button"
                                                onClick={() =>
                                                    handleOpenPatientModalForIndex(
                                                        formik.values.member.length
                                                    )
                                                }
                                            >
                                                Add New Patient
                                            </Button>
                                        </>
                                    ) : (
                                        <Button
                                            type="button"
                                            variant="secondary"
                                            onClick={() =>
                                                handleOpenPatientModalForIndex(
                                                    formik.values.member?.length || 0
                                                )
                                            }
                                            disabled={!formik.values.orgId}
                                        >
                                            Add Patient
                                        </Button>
                                    )}
                                    <div>
                                        {formik?.touched["member"] &&
                                        formik?.errors["member"] ? (
                                            <div className="error-text">
                                                {formik?.errors["member"]}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            ) : (
                                <div className="field-wrap">
                                    <label>Select Members</label>
                                    <Select
                                        onChange={(data) => formik.setFieldValue("member", data)}
                                        isMulti
                                        name="member"
                                        options={usersList}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                    <div>
                                        {formik?.touched["member"] &&
                                        formik?.errors["member"] ? (
                                            <div className="error-text">
                                                {formik?.errors["member"]}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <TextArea required={false} keyField={"description"} label={"Description"} formik={formik} placeholder={"Description..."} />
                        </Col>
                        <Col></Col>
                    </Row>
                    <div className="btn-wrap" style={{ display: 'flex' }}>
                        <Button onClick={() => navigate("/app/manage-groups")} variant="secondary" title="Cancel">Cancel</Button>
                        <Button type="submit" isLoading={btnLoading}>Create</Button>
                    </div>
                </form>
                <PatientSelectModal
                    show={showPatientSelectionModal}
                    orgId={formik.values.orgId}
                    onHide={() => {
                        setShowPatientSelectionModal(false);
                        setPatientSelectionIndex(null);
                    }}
                    onPatientSelected={handlePatientSelected}
                    initialPatient={null}
                    resetPatient={() => {}}
                />
            </div>
        </section>
    );
}

export default AddGroup;